/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'docx': {
    width: 40,
    height: 50,
    viewBox: '0 0 40 50',
    data: '<g stroke-width="2" _stroke="#55595E" stroke-linecap="round" stroke-linejoin="round" _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h28v12h12v38H0zM28 0l12 12"/></g><g _fill="none" fill-rule="evenodd"><path pid="1" d="M28 0l12 12" _stroke="#55595E" stroke-width="2"/><path pid="2" _fill="#2296E1" d="M6 21h28v2H6zM6 15h14v2H6zM6 27h28v2H6zM6 33h28v2H6zM6 39h28v2H6z"/></g>'
  }
})
